// Agenda de visitas (AgendarForm, BookingModal, ManageAppointment, AppointmentsManagerModal, tokenAppointment, CalendarGrid) — English (US). Mismas claves que es/booking.ts.
// Los `{{x}}` los completa `fill` de components/booking/bookingShared.
export const bookingEn = {
  common: {
    branch: 'Location',
    branchNumber: 'Location #{{id}}',
    viewMyAppointments: 'View my appointments',
    edit: 'Edit',
    yourData: 'Your information',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    firstNamePlaceholder: 'John',
    lastNamePlaceholder: 'Smith',
    emailPlaceholder: 'name@example.com',
    phonePlaceholder: '+1 (555) 123-4567',
    saveMyData: 'Save my information',
    noteOptional: 'Note (optional)',
    notePlaceholder: "e.g. I'm bringing someone with me, I'd like to see the trunk, etc.",
    selectBranchAria: 'Select a location',
    selectBranchPlaceholder: 'Select a location',
    grayDaysHint: 'Grayed-out days are shown to keep the calendar view, but they have no available times.',
    slotsFor: 'Available times for {{date}}',
    noSlots: 'There are no available times for that date. Try another day.',
    visitReason: 'Reason for your visit',
    bookVisit: 'Book a visit',
    bookAnother: 'Book another visit',
    cancelAppointment: 'Cancel appointment',
    close: 'Close',
    back: 'Back',
  },
  // Etiqueta visible de cada motivo. El VALOR guardado (service_name) no cambia.
  reasons: {
    verVehiculo: 'See a vehicle',
    tasarAuto: 'Get my car appraised',
    financiamiento: 'Financing',
    otraConsulta: 'Other question',
    consignarAuto: 'Consign my car',
    venderAuto: 'Sell my car',
    visitaShowroom: 'showroom visit',
    visita: 'visit',
  },
  toast: {
    slotsLoadError: 'Error loading available times: {{error}}',
    missingClientId: 'Missing client_id',
    completeData: 'Please complete your information correctly',
    dataSaved: 'Information saved',
    dataSaveFailed: "We couldn't save your information",
    completeToContinue: 'Complete your information to continue.',
    completeAndSaveToContinue: 'Complete and save your information to continue.',
    emailFailed: "Your appointment is booked, but we couldn't send the confirmation to your email.",
    slotTaken: 'That time was just taken. Please choose another time.',
    alreadyBooked: 'You already have an appointment at that time.',
    tooMany: 'You already have the maximum number of active appointments. Cancel one to book another.',
    slotUnavailable: 'That time is no longer available. Please choose another one.',
    createFailed: "We couldn't create the appointment: {{code}}",
    booked: 'Your appointment has been booked!',
    requested: 'Request sent. The dealership will confirm your visit.',
  },
  email: {
    confirmSubject: 'Appointment confirmation: {{reason}}',
    newSubject: 'New appointment: {{reason}}',
    confirmSubjectVehicle: 'Appointment Confirmation: {{vehicle}}',
    newSubjectVehicle: 'New Appointment Booked: {{vehicle}}',
    requestSubject: 'We received your appointment request: {{reason}}',
    newPendingSubject: 'New appointment TO ACCEPT: {{reason}}',
    requestSubjectVehicle: 'We received your appointment request: {{vehicle}}',
    newPendingSubjectVehicle: 'New appointment TO ACCEPT: {{vehicle}}',
    sellerSubject: 'New Appointment for your vehicle: {{brand}} {{model}}',
    cancelledSubject: 'Appointment Canceled: {{brand}} {{model}}',
    cancelledSellerSubject: 'Appointment Canceled for your vehicle: {{brand}} {{model}}',
    customerFallback: 'Customer',
  },
  calendar: {
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    noSlots: 'No available times',
    loadingMonth: "Loading this month's availability…",
    wd0: 'S',
    wd1: 'M',
    wd2: 'T',
    wd3: 'W',
    wd4: 'T',
    wd5: 'F',
    wd6: 'S',
  },
  // AgendarForm (/agendar y bloque del builder)
  form: {
    title: 'Book a Visit',
    subtitleBefore: 'Book a time with ',
    subtitleAfter: " and we'll be expecting you.",
    subtitleFallbackName: 'us',
    stepDayTime: 'Day and time',
    stepReasonData: 'Reason and details',
    stepConfirm: 'Confirm',
    done: "You're all set!",
    expectOn: "We'll see you on ",
    doneRequested: 'Request sent!',
    requestedOn: 'You asked for ',
    requestedNote: "We'll confirm as soon as we review it. The time slot stays reserved in the meantime.",
    expectAt: ' at ',
    // "…at 2:30 PM — 742 Evergreen Terrace." (no "at 2:30 PM at 742…")
    expectIn: ' —',
    reasonPrefix: 'Reason: ',
    loadingBranches: 'Loading locations…',
    chooseDay: 'Choose a day',
    chooseSlot: 'Choose a time',
    pickDateFirst: 'First, choose a date on the calendar.',
    reviewConfirm: 'Review and confirm',
    summaryDay: 'Day',
    summaryTime: 'Time',
    summaryReason: 'Reason',
    summaryName: 'Name',
    summaryNote: 'Note',
    back: 'Back',
    continue: 'Continue',
  },
  // BookingModal (ficha del vehículo)
  modal: {
    selectBranch: 'Select a location',
    timezone: 'Time zone: ',
    stepDate: 'Date',
    stepTime: 'Time',
    manageTooltip: 'Review and manage your appointments',
    selectDate: 'Select a date',
    pickDateFirst: 'First, choose a date.',
    summary: 'Summary',
    chooseDate: 'Choose date',
    chooseTime: 'Choose time',
    confirm: 'Confirm appointment',
  },
  // AppointmentsManagerModal ("Mis citas")
  manager: {
    title: 'My appointments',
    fetchFailed: "We couldn't load your appointments",
    pastCannotCancel: "A past appointment can't be canceled.",
    notFound: "We couldn't find the appointment",
    cancelFailedMaybe: "We couldn't cancel the appointment (it may have already passed or already been canceled).",
    cancelled: 'Appointment canceled',
    cancelFailed: "We couldn't cancel the appointment",
    empty: "You don't have any upcoming appointments.",
    note: 'Note:',
    rescheduleHelp: 'To reschedule, cancel and book again.',
    help: 'Help',
    confirmTitle: 'Confirm cancellation',
    confirmText: 'Do you want to cancel this appointment? You can add a reason (optional).',
    reasonPlaceholder: "e.g. I won't be able to make it, I need to reschedule, etc.",
    // Estado crudo de la base: en inglés se muestra con mayúscula inicial.
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
  },
  // ManageAppointment (/agendar/gestionar)
  manage: {
    title: 'Manage my visit',
    notFoundHint: 'If you booked it recently, check the link in the message you received.',
    cancelledTitle: 'Your visit was canceled.',
    cancelledText: 'If you want to come another day, you can book again anytime.',
    rescheduledTitle: 'Your appointment was rescheduled.',
    rescheduledText: "We'll see you at the new time.",
    date: 'Date',
    time: 'Time',
    reason: 'Reason',
    viewDetail: 'View my visit details',
    stepConfirm: 'Confirm',
    whichDay: 'Which day works best for you?',
    whichTime: 'What time?',
    noSlotsLeft: 'There are no times left that day. Try another one.',
    confirmChange: 'Confirm the change',
    newDate: 'New date',
    newTime: 'New time',
    keepsNote: 'The location and reason stay the same. Your previous time slot will be released.',
    confirmNewSlot: 'Confirm new time',
    wasRescheduled: 'This visit was rescheduled.',
    leftForOn: 'Your visit is now scheduled for ',
    leftForAt: ' at ',
    viewNewVisit: 'View my new visit',
    cancelledState: 'This visit has been canceled. If you want to come another day, you can book again.',
    doneState: 'This visit has already taken place. Thanks for coming!',
    tooSoon: "Your visit is coming up very soon. If you can't make it, please call the location.",
    reschedule: 'Reschedule',
    confirmCancelQuestion: 'Do you want to cancel your visit?',
    confirmCancelText: "You'll lose this time slot. You can book another one later.",
    yesCancel: 'Yes, cancel',
    noBack: 'No, go back',
  },
  // src/app/agendar/page.tsx (host sin tenant)
  page: {
    unavailableTitle: 'Scheduling unavailable',
    unavailableText: "We couldn't identify the dealership. Check the link and try again.",
  },
};
